import React from 'react';
import { Textarea, TextareaProps } from '@mantine/core';

export function ETextArea({ ...props }: TextareaProps) {
    return (
        <Textarea
            radius="md"
            size="md"
            {...props}
        />
    )
}